<template>
<div class="wraps">
    <div class="basic">
    <el-collapse v-model="activeNames" >
 <el-collapse-item>
    <template slot="title">
      <span class="titlebar">基本情况</span>
    </template>
    <div class="basiccon">
    <el-form :inline="true" :model="basicMsg" label-width="120px" class="demo-form-inline">
  <el-form-item label="姓名">
    <el-input v-model="basicMsg.name" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="性别">
      <el-select v-model="basicMsg.gender" size="small" placeholder="请选择">
    <el-option
      v-for="item in genderList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item label="民族">
    <el-input v-model="basicMsg.nation" size="small" placeholder="民族"></el-input>
  </el-form-item>
  <el-form-item label="身份证号">
    <el-input v-model="basicMsg.idcard" size="small" placeholder="身份证号"></el-input>
  </el-form-item>
  <el-form-item label="出生日期">
       <el-date-picker
      v-model="basicMsg.birthday"
      type="date"
      size="small"
      placeholder="选择日期">
    </el-date-picker>
  </el-form-item>
  <el-form-item label="手机号码">
    <el-input v-model="basicMsg.tel" size="small" placeholder="手机号码"></el-input>
  </el-form-item>
  <el-form-item label="政治面貌">
    <el-input v-model="basicMsg.politicalLandscape" size="small" placeholder="政治面貌"></el-input>
  </el-form-item>
  <el-form-item label="健康状况">
    <el-input v-model="basicMsg.health" size="small" placeholder="健康状况"></el-input>
  </el-form-item>
  <el-form-item label="原工作单位">
    <el-input v-model="basicMsg.originalWorkUnit" size="small" placeholder="原工作单位"></el-input>
  </el-form-item>
  <el-form-item label="原任职务">
    <el-input v-model="basicMsg.originalPosition" size="small" placeholder="原任职务"></el-input>
  </el-form-item>
  
  <el-form-item label="退休年月">
      <el-date-picker
      v-model="basicMsg.retiredDate"
      type="date"
      size="small"
      placeholder="选择日期">
    </el-date-picker>
  </el-form-item>
   <el-form-item label="文化程度">
    <el-input v-model="basicMsg.educationLevel" size="small" placeholder="文化程度"></el-input>
  </el-form-item>
  <el-form-item label="档案存放地点">
    <el-input v-model="basicMsg.archivesAddress" size="small" placeholder="档案存放地点"></el-input>
  </el-form-item>
  <el-form-item label="特长">
    <el-input v-model="basicMsg.specialty" size="small" placeholder="特长"></el-input>
  </el-form-item>
  <el-form-item label="参加工作时间">
    <el-date-picker
      v-model="basicMsg.enterServiceDate"
      type="date"
      size="small"
      placeholder="选择日期">
    </el-date-picker>
  </el-form-item>
  <el-form-item label="爱好">
    <el-input v-model="basicMsg.hobbies" size="small" placeholder="爱好"></el-input>
  </el-form-item>
  <el-form-item label="特殊人员情况">
     <el-select v-model="basicMsg.specialCase" size="small" placeholder="请选择">
    <el-option
      v-for="item in specialCaseList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
   <el-form-item label="备注">
    <el-input  v-model="basicMsg.remark" size="small" placeholder="备注"></el-input>
  </el-form-item>
</el-form>
</div>
  </el-collapse-item>
  <el-collapse-item >
    <template slot="title">
      <span class="titlebar">参保情况</span>
    </template>
    <el-form :inline="true" :model="basicMsg" class="demo-form-inline">   
    <el-form-item label="社会保险关系所在地">
      <Candode1 v-on:childByValue="childByValueSocial"></Candode1>
  </el-form-item>
  
   <el-form-item label="社会保障号码">
    <el-input v-model="basicMsg.socialSecurityNo" size="small" placeholder="社会保障号码"></el-input>
  </el-form-item>
   <el-form-item label="参保类别">
    <el-select size="small" v-model="basicMsg.socialSecurityType" placeholder="请选择">
    <el-option
      v-for="item in socialSecurityTypeList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
   <el-form-item label="移交地县（市、区）">
    <Candode1 v-on:childByValue="childByValue"></Candode1>
  </el-form-item>
  </el-form>
   </el-collapse-item>
   <!-- 家庭情况 -->
  <el-collapse-item>
    <template slot="title">
      <span class="titlebar">家庭情况</span>
    </template>
    <el-form :inline="true" :model="basicMsg" class="demo-form-inline">   
  <el-form-item label="现居住地址">
      <Candode1 v-on:childByValue="childByValueNow"></Candode1>
  </el-form-item>
  <el-form-item label="">
       <el-input v-model="basicMsg.dwellAddressNumber" size="small" placeholder="门牌号"></el-input>
  </el-form-item>
   <el-form-item label="户口所在地">
      <Candode1 v-on:childByValue="childByValueRegist"></Candode1>
  </el-form-item>
  <el-form-item label="">
       <el-input v-model="basicMsg.registAddressNumber" size="small" placeholder="门牌号"></el-input>
  </el-form-item>
   <el-form-item label="参保类别">
    <el-select size="small" v-model="basicMsg.socialSecurityType" placeholder="请选择">
    <el-option
      v-for="item in socialSecurityTypeList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  </el-form>
   </el-collapse-item>
  <el-collapse-item>
    <template slot="title">
      <span class="titlebar">家庭其他联系人</span>
    </template>
    <el-form :inline="true" :model="basicMsg" class="demo-form-inline">   
   <el-form-item label="姓名">
    <el-input v-model="basicMsg.kinsfolkName" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="关系">
    <el-input v-model="basicMsg.kinsfolkRelation" size="small" placeholder="关系"></el-input>
  </el-form-item>
  <el-form-item label="工作单位">
    <el-input v-model="basicMsg.kinsfolkWorkUnit" size="small" placeholder="工作单位"></el-input>
  </el-form-item>
  <el-form-item label="联系电话">
    <el-input v-model="basicMsg.kinsfolkTel" size="small" placeholder="联系电话"></el-input>
  </el-form-item>
   <el-form-item label="详细地址">
    <Candode1 v-on:childByValue="childByValuekinsfolk"></Candode1>
  </el-form-item>
  <el-form-item label="邮政编码">
    <el-input v-model="yzcode1" size="small" placeholder="邮政编码"></el-input>
  </el-form-item>
  <hr style='background-color:lightgray; height:1px; border:none;'>
  <el-form-item label="姓名">
    <el-input v-model="basicMsg.kinsfolkNameBak" size="small" placeholder="姓名"></el-input>
  </el-form-item>
  <el-form-item label="关系">
    <el-input v-model="basicMsg.kinsfolkRelationBak" size="small" placeholder="关系"></el-input>
  </el-form-item>
  <el-form-item label="工作单位">
    <el-input v-model="basicMsg.kinsfolkWorkUnitBak" size="small" placeholder="工作单位"></el-input>
  </el-form-item>
  <el-form-item label="联系电话">
    <el-input v-model="basicMsg.kinsfolkTelBak" size="small" placeholder="联系电话"></el-input>
  </el-form-item>
   <el-form-item label="详细地址">
    <Candode1 v-on:childByValue="childByValuekinsfolkBak"></Candode1>
  </el-form-item>
  <el-form-item label="邮政编码">
    <el-input v-model="yzcode2" size="small" placeholder="邮政编码"></el-input>
  </el-form-item>
  </el-form>
   </el-collapse-item>
   <el-collapse-item>
    <template slot="title">
      <span class="titlebar">上传身份证/个人头像</span>
    </template>
  <div class="tilcon">
 <div class="upload" @click="toIdCard(1)">
   <span v-show="!isi">上传身份证</span>
   <img v-show="isi" :src="idcardImg" alt="">
 </div>
 <div class="upload uploadheader" @click="toIdCard(2)">
   <span v-show="!ish">上传个人头像<br></span>
   <img v-show="ish" :src="headerImg" alt="">
 </div>
 </div>
 <input type="file" v-show="false" @change="uploadIdCard($event)" ref="idcard">
   </el-collapse-item>
   <el-collapse-item>
    <template slot="title">
      <span class="titlebar">上传档案资料</span>
    </template>
  <div class="tilcon">
  <div class="uploadda" v-for="(item,index) in daImgList" :key='index'>
    <div class="el-icon-delete del" @click="delImg(index)"></div>
    <img :src="imgUrl+item.imageUrl" alt="">
  </div>
 <div class="uploadda" @click="toDa">
  <i class="el-icon-plus"></i>
 </div>
 </div>
 <input type="file" v-show="false" @change="uploadDa($event)" ref="da">
   </el-collapse-item>
</el-collapse>
    </div>
   <div class="reg"><el-button @click="reg" style="width:150px" type="primary">登记</el-button></div>
</div>
</template>
<script>
import Candode1 from "../Core/shiftcandode"
import {formatDate} from '../../utils/datetimeYMR'
export default {
  components:{
      Candode1
      },
    data(){
      
        return{
            ish:false,
            isi:false,
            idcardImg:'',
            imgUrl:'http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/',
            headerImg:'',
            n:true,
            socialList:'',
            shifttownList:'',
            nowaddressList:'',
            registaddressList:'',
            kinsfolkList:'',
            kinsfolkbakList:'',
            yzcode1:'',
            idCardUrl:'',
            daImgList:[],
            yzcode2:'',
            basicMsg:{
              "name": "",
              "gender": "",
              "nation": "",
              "birthday": "",
              "tel": "",
              "politicalLandscape": "",
              "health": "",
              "originalWorkUnit": "",
              "originalPosition": "",
              "retiredDate": "",
              "idcard":"",
              "archivesAddress": "",
              "educationLevel": "",
              "specialty": "",
              "enterServiceDate": "",
              "hobbies": "",
              "specialCase": "",
              "socialSecurityAddress": "",
              "socialSecurityNo": "",
              "socialSecurityType": "",
              "shiftAddressProvice": "",
              "shiftAddressCounty": "",
              "shiftAddressCity": "",
              "shiftAddressStreet": "",
              "shiftAddressCommunity": "",
              "operator": sessionStorage.getItem("user"),
              "checkInDate":formatDate(new Date()),
              "remark": "",
              "dwellAddressProvice": "",
              "dwellAddressCounty": "",
              "dwellAddressCity": "",
              "dwellAddressStreet": "",
              "dwellAddressCommunity": "",
              "dwellAddressNumber": "",
              "registAddressProvice": "",
              "registAddressCounty": "",
              "registAddressCity": "",
              "registAddressStreet": "",
              "registAddressCommunity": "",
              "registAddressNumber": "",
              "kinsfolkName": "",
              "kinsfolkRelation": "",
              "kinsfolkWorkUnit": "",
              "kinsfolkTel": "",
              "kinsfolkAddrees": "",
              "kinsfolkNameBak": "",
              "kinsfolkRelationBak": "",
              "kinsfolkWorkUnitBak": "",
              "kinsfolkTelBak": "",
              "kinsfolkAddreesBak": "",
              "images":[]
            },
            specialCaseList:[{
                label:"建国前参加工作",
                value:'建国前参加工作'
            },{
                label:"八十岁以上高龄",
                value:'八十岁以上高龄'
            },{
                label:"孤寡老人",
                value:'孤寡老人'
            },{
                label:"劳模",
                value:'劳模'
            },{
                label:"特困",
                value:'特困'
            },{
                label:"重病",
                value:'重病'
            },{
                label:"残疾",
                value:'残疾'
            }],
            socialSecurityTypeList:[{
                label:"养老",
                value:'0'
            },{
                label:"医疗",
                value:'1'
            }],
            genderList:[
              {
                label:"男",
                value:1
              }, {
                label:"女",
                value:0
              }
            ],
            activeNames: ['1']
        }
    },
    methods:{
      formatDate:formatDate,
      childByValue(val){
        this.shifttownList=val
       // this.serchCode()
      },
      childByValueSocial(val){
         this.socialList=val
      },
      childByValueNow(val){
        this.nowaddressList=val
      },
      //户口所在地
      childByValueRegist(val){
         this.registaddressList=val
      },
      //家庭成员1
      childByValuekinsfolk(val){
        this.kinsfolkList=val
      },
      //家庭成员2
      childByValuekinsfolkBak(val){
        this.kinsfolkbakList=val
      },
      toIdCard(s){
        if(s==1){
          this.n=true
        }else{
          this.n=false
        }
        this.$refs.idcard.click()
      },
      //上传身份证呢
      uploadIdCard(e){     
        let file=e.target.files[0]
        let that=this
        //图片压缩
          lrz( file, {
              width : 300
              //quality: 0.8    //自定义使用压缩方式
          })  
            .then(function(rst) { 
                let data = {
                  "libid": that.basicMsg.idcard,
                  "imageBase64str":rst.base64.split(",")[1]
                }
                that.$api.getlist.etiress(data).then(res=>{
                  if(res.code==200){
                  if(that.n){
                    for(let i in that.basicMsg.images){
                      if(that.basicMsg.images[i].imageType=="身份证"){
                        that.basicMsg.images.splice(i,1)
                      }
                    }
                  that.basicMsg.images.push({
                  "imageType":"身份证",
                  "imageName":rst.origin.name,
                  "sortIndex":"1",
                  "imageUrl":res.data
                  })
                  that.isi=true
                  that.idcardImg=rst.base64
                  }else{
                     for(let i in that.basicMsg.images){
                      if(that.basicMsg.images[i].imageType=="个人头像"){
                        that.basicMsg.images.splice(i,1)
                      }
                    }
                    that.basicMsg.images.push({
                  "imageType":"个人头像",
                  "imageName":rst.origin.name,
                  "sortIndex":"1",
                  "imageUrl":res.data
                  })
                  that.ish=true
                  that.headerImg=rst.base64
                  }
        }else{
          that.$message({
            type:"warning",
            message:res.message
          })
        }
                }).catch(err=>{

                })
            }).catch(function(error) {
                //失败时执行
            }).always(function() {
                //不管成功或失败，都会执行
            })
      },
      uploadDa(e){
         let file=e.target.files[0]
        let that=this
        //图片压缩
          lrz( file, {
              width : 300
              //quality: 0.8    //自定义使用压缩方式
          })  
            .then(function(rst) { 
                let data = {
                  "libid": that.basicMsg.idcard,
                  "imageBase64str":rst.base64.split(",")[1]
                }
                that.$api.getlist.etiress(data).then(res=>{
                  if(res.code==200){
                  
                  that.daImgList.push({
                  "imageType":"档案资料",
                  "imageName":rst.origin.name,
                  "sortIndex":that.daImgList.length+1,
                  "imageUrl":res.data
                  })                      
        }else{
          that.$message({
            type:"warning",
            message:res.message
          })
        }
                }).catch(err=>{

                })
            }).catch(function(error) {
                //失败时执行
            }).always(function() {
                //不管成功或失败，都会执行
            })
      },
      toDa(){
        this.$refs.da.click()
      },
      delImg(s){
        this.daImgList.splice(s,1)
      },
      reg(){
        this.basicMsg.checkInDate=this.basicMsg.checkInDate?formatDate(this.basicMsg.checkInDate):''
        this.basicMsg.retiredDate=this.basicMsg.retiredDate?formatDate(this.basicMsg.retiredDate):''
        this.basicMsg.birthday=this.basicMsg.birthday?formatDate(this.basicMsg.birthday):''
        this.basicMsg.checkInDate=this.basicMsg.checkInDate?formatDate(this.basicMsg.checkInDate):''
    
        this.basicMsg.socialSecurityAddress=(this.socialList[0]?this.socialList[0].split(",")[1]:'')+(this.socialList[1]?this.socialList[1].split(",")[1]:'')+(this.socialList[2]?this.socialList[2].split(",")[1]:'')+(this.socialList[3]?this.socialList[3].split(",")[1]:'')+(this.socialList[4]?this.socialList[4].split(",")[1]:'')
        
      
        this.basicMsg.shiftAddressProvice=this.shifttownList[0]?this.shifttownList[0].split(",")[1]:''
        this.basicMsg.shiftAddressCounty=this.shifttownList[1]?this.shifttownList[1].split(",")[1]:''
        this.basicMsg.shiftAddressCity=this.shifttownList[2]?this.shifttownList[2].split(",")[1]:''
        this.basicMsg.shiftAddressStreet=this.shifttownList[3]?this.shifttownList[3].split(",")[1]:''
        this.basicMsg.shiftAddressCommunity=this.shifttownList[4]?this.shifttownList[4].split(",")[1]:''
        this.basicMsg.dwellAddressProvice=this.nowaddressList[0]?this.nowaddressList[0].split(",")[1]:''
        this.basicMsg.dwellAddressCounty=this.nowaddressList[1]?this.nowaddressList[1].split(",")[1]:''
        this.basicMsg.dwellAddressCity=this.nowaddressList[2]?this.nowaddressList[2].split(",")[1]:''
        this.basicMsg.dwellAddressStreet=this.nowaddressList[3]?this.nowaddressList[3].split(",")[1]:''
        this.basicMsg.dwellAddressCommunity=this.nowaddressList[4]?this.nowaddressList[4].split(",")[1]:''
      
         this.basicMsg.registAddressProvice=this.registaddressList[0]?this.registaddressList[0].split(",")[1]:''
        this.basicMsg.registAddressCounty=this.registaddressList[1]?this.registaddressList[1].split(",")[1]:''
        this.basicMsg.registAddressCity=this.registaddressList[2]?this.registaddressList[2].split(",")[1]:''
        this.basicMsg.registAddressStreet=this.registaddressList[3]?this.registaddressList[3].split(",")[1]:''
        this.basicMsg.registAddressCommunity=this.registaddressList[4]?this.registaddressList[4].split(",")[1]:''

        this.basicMsg.kinsfolkAddrees=(this.kinsfolkList[0]?this.kinsfolkList[0].split(",")[1]:'')+(this.kinsfolkList[1]?this.kinsfolkList[1].split(",")[1]:'')+(this.kinsfolkList[2]?this.kinsfolkList[2].split(",")[1]:'')+(this.kinsfolkList[3]?this.kinsfolkList[3].split(",")[1]:'')+(this.kinsfolkList[4]?this.kinsfolkList[4].split(",")[1]:'')

        this.basicMsg.kinsfolkAddreesBak=(this.kinsfolkbakList[0]?this.kinsfolkbakList[0].split(",")[1]:'')+(this.kinsfolkbakList[1]?this.kinsfolkbakList[1].split(",")[1]:'')+(this.kinsfolkbakList[2]?this.kinsfolkbakList[2].split(",")[1]:'')+(this.kinsfolkbakList[3]?this.kinsfolkbakList[3].split(",")[1]:'')+(this.kinsfolkbakList[4]?this.kinsfolkbakList[4].split(",")[1]:'')
        
        this.basicMsg.images=this.basicMsg.images.concat(this.daImgList)
         this.$api.getlist.retiress(this.basicMsg).then(res=>{
              if(res.code==200){
                this.$message({
                  type:"success",
                  message:"登记成功"
                })
              }else{
                 this.$message({
                  type:"warning",
                  message:res.message
                })
              }
              this.basicMsg.images=this.basicMsg.images.splice(0,1)
         }).catch(err=>{

         })
      }
    },
    
}
</script>
<style scoped>
.wraps{
    background: #f5f5f5;
}
.titlebar{
  font-size: 16px;
  font-weight: bolder;
}
.tilcon{
  display: flex;
  flex-wrap:wrap
}
.basic{
    background: #ffffff; 
    border: 1px solid lightgray;  
    padding: 10px;
    box-shadow: 1px 1px 1px lightgray;
    border-radius: 10px;
    overflow: hidden;
}
.uploadda{
  width: 200px;
  height: 200px;
  border: 1px solid lightgray;
  border-radius: 10px;
  line-height: 200px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
}
.uploadda:hover .del{
  z-index: 1;
}
.del{
  position: absolute;
  width:100%;
  height: 100%;
  line-height: 200px;
  background: black;
  opacity: 0.5;
  z-index: -1;
  right: 0;
  font-size: 40px;
  color: #ffffff;
  top: 0;
}
.uploadda img{
  height: 200px;
  width:200px;
  object-fit: cover;
}
.basiccon{
    padding: 10px;
}
.til{   
        padding:0 0 10px 10px;
        border-bottom: 1px solid lightgray;
        font-weight: bolder;
    }
.basiccon .el-form-item{
  width: 350px;
}
.reg{
  text-align: center;
  padding: 20px;
  background: #ffffff;
}
.upload{
  width: 300px;
  height: 200px;
  border: 1px dashed lightgray;
  border-radius: 10px;
  color: lightgray;
  text-align: center;
  line-height: 200px;
 font-size: 18px;
}
.uploadheader{
  width: 200px;
  margin-left: 20px;
}
.upload img{
  height: 200px;
  width:300px;
  object-fit: cover;
}
.uploadheader img{
  height: 200px;
  width:200px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/views/shangCheng/msgCollect.vue